import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { lookupClientAccess, portalPathForClient } from "../../js/api/clientAccess";
import { writeClientPortal } from "../../js/hooks/useClientPortal";

export default function ClientAccessPanel({ quiet = false }) {
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [verify, setVerify] = useState("");
  const [error, setError] = useState("");

  function submit(event) {
    event.preventDefault();
    const result = lookupClientAccess({ code, verify });
    if (!result.ok) {
      setError(result.error);
      return;
    }
    writeClientPortal(result.client);
    navigate(portalPathForClient(result.client));
  }

  return (
    <section className={`client-access card${quiet ? " client-access--quiet" : ""}`} data-tour="client-access">
      <p className="home-kicker">Client ID</p>
      <h2>{quiet ? "I have a Client ID" : "Open my portal"}</h2>
      <p className="muted">
        Enter the Client ID your agent gave you. You will only see your buyer or seller portal — never
        the professional desk.
      </p>
      <form className="client-access__form" onSubmit={submit}>
        <label>
          Client ID
          <input
            value={code}
            onChange={(event) => setCode(event.target.value)}
            placeholder="RC-BY-4821"
            autoComplete="off"
          />
        </label>
        <label>
          Last name or email <span className="muted">(optional)</span>
          <input value={verify} onChange={(event) => setVerify(event.target.value)} />
        </label>
        {error ? <p className="field-error">{error}</p> : null}
        <button type="submit" className="primary-btn">
          Open My Portal
        </button>
      </form>
    </section>
  );
}
